$(document).ready(function() {
  var win = $(window),isInProgress = false;
  win.on('scroll',function() {
    if(!isInProgress) {
      if ((win.scrollTop()+win.height()) >= $('.footer-sec').offset().top) {
        var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
        if(currentPage >= totalPages) return;
        currentPage = currentPage+1;
        var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
        $('[data-current-page]').val(currentPage);
        isInProgress = true;
        $('.block__latest-article-loader-block').addClass('show');
        $.ajax({
          url: nextUrl,
          type: 'GET',
          dataType: 'html',
          success: function(responseHTML){
            $('.block__latest-article-row').append($(responseHTML).find('.block__latest-article-row').html());
          },
          complete: function(){
            isInProgress = false;
            $('.block__latest-article-loader-block').removeClass('show');
          }
        });
      }
    }
  });
});
